import { api, signalr } from '@/f1/service';
import Language from './language';
import moduleitem from '@/f1/views/WebCastle/castleItem.i18n';
import moment from 'moment-timezone';
import agent from '../../WebCastle/modules/service'
import logList from '../../WebCastle/log/Log.List.i18n'
import _ from 'lodash';

export default {
  components : { 'agent-item' : moduleitem, logList, Language },
  computed: {
  },
  data: () => {
    return {
      signalr : signalr.socket(),
      pong : { list : [], cnt : 12 },
      th : undefined,
      use_view : true,
      load_agent : [],
      info : { day : 0, week : 0, month : 0 }
    }
  },
  methods: {
    value_comma(v) {
      return (v.toFixed(0) || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    async ping(){
      if(this.th) { clearTimeout(this.th); }
      if(this.load_agent && this.load_agent.length){
        for(let i = 0; i < this.load_agent.length; i++){
          try { agent.Cmd("ping", this.load_agent[i].id); } catch (e) { console.error(e) }
        }
        this.th = setTimeout(this.ping, 3000)
      }
    },
    default_info() { return { block : 0, detect : 0, total : 0 } },
    res(m) { _.indexOf(this.pong.list, m.agent_id) == -1 ? this.pong.list.push(m.agent_id) : '' },
    load() {
      api.webcastle.WebCastle_Call("dashboard", "month").then(rs => {
        let today = moment();

        this.info.day = this.default_info()
        this.info.week = this.default_info()
        this.info.month = this.default_info()

        for (let i = 0; i < rs.body.data.length; i++) {
          const r = rs.body.data[i];
          let rdate = moment(r.date);

          if(rdate.month() == today.month()) { this.info.month.block += r.block; this.info.month.total += r.total; }
          if(moment.duration(rdate.diff(today)).asDays() > -8) { this.info.week.block += r.block; this.info.week.total += r.total; }
          if(moment.duration(rdate.diff(today)).asDays() > -1) { this.info.day.block += r.block; this.info.day.total += r.total; }
        }
        this.info.month.detect = this.info.month.total - this.info.month.block
        this.info.week.detect = this.info.week.total - this.info.week.block
        this.info.day.detect = this.info.day.total - this.info.day.block

      }).catch(e => this.catch_msg(e));

      api.webcastle.WebCastle_Call("dashboard", "agent").then(rs => {
        if(rs.is_error) { return this.$toastr.e("load failed") }
        this.info.module = { alive : 0, deleted : 0 };
        this.info.module.deleted = rs.body.data.deleted;
        this.info.module.alive = rs.body.data.total - rs.body.data.deleted

      }).catch(e => this.catch_msg(e));

      _.forEach(this.$refs, x => { try { console.log(x._uid, 'start') && x && x.play && x.indexOf('_check_') > -1 && x.play() } catch (e) { console.log(e); }})

      api.webcastle.WebCastle_Call("agent", "list", { offset : 0, limit :  100, sort : [ { name : "id", op : "desc" } ], request: 'webcastle' })
        .then(rs => { this.load_agent = rs.body; this.ping() }).catch(e => this.catch_msg(e));
      return this.load_log;
    },
    catch_msg(e) { console.error(e); this.$toastr.e(e.data ? e.data.message : e.statusText); },
    refresh() {
      if(!this.th) { this.th = setTimeout(() => this.refresh, 5000); }
    },
  },
  mounted () {
    console.log('dashboard.vue mounted');
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
    this.signalr.on('webcastle', this.res)
    this.load();
  },
  destroyed () {
    this.signalr.off('webcastle');
    console.log('dashboard.vue destroyed');
  },
}
